import { reactive, ref } from 'vue';

import authorizeRequest from '@/api/authorize';
import logoutRequest from '@/api/logout';
import refreshTokenRequest from '@/api/refreshToken';
import { useKYC } from '@/hooks/useKYC';
import { debounce } from '@/utils/debounce';
import { setResponseInterceptor } from '@/utils/http';

const AUTHORIZATION_TOKEN_LOCALSTORAGE_KEY = 'authorization-key';
export const IFRAME_KYC_URL_LOCALSTORAGE_KEY = 'iframe-kyc-url';

export const isAuthorized = ref(false);

export const checkAuthorization = () => {
  isAuthorized.value = Boolean(window.localStorage.getItem(AUTHORIZATION_TOKEN_LOCALSTORAGE_KEY));

  return isAuthorized.value;
};

export const logout = async () => {
  try {
    await logoutRequest();
  } catch (err) {
    console.error(err);
  }
  window.localStorage.removeItem(AUTHORIZATION_TOKEN_LOCALSTORAGE_KEY);
  window.localStorage.removeItem(IFRAME_KYC_URL_LOCALSTORAGE_KEY);

  isAuthorized.value = false;
};

export const userInfo = reactive(
  {
    id: null,
    statusVerification: null,
    reasonsErrors: {},
    isConfirmAgentAgreement: null,
  },
);

const errorHandler = async (err) => {
  await logout();
  console.error(err);
};

export const authorize = async (login, password) => {
  try {
    const { data } = await authorizeRequest(login, password);
    window.localStorage.setItem(AUTHORIZATION_TOKEN_LOCALSTORAGE_KEY, data);

    isAuthorized.value = true;
  } catch (err) {
    await errorHandler(err);
  }
};

const refreshAccessToken = async () => {
  try {
    const { data } = await refreshTokenRequest();
    window.localStorage.setItem(AUTHORIZATION_TOKEN_LOCALSTORAGE_KEY, data);
    window.location.reload();
  } catch (err) {
    window.localStorage.removeItem(AUTHORIZATION_TOKEN_LOCALSTORAGE_KEY);
    throw err;
  }
};

const handle401Error = debounce(async () => {
  try {
    return await refreshAccessToken();
  } catch (refreshErr) {
    return errorHandler(refreshErr);
  }
}, 300);

setResponseInterceptor(null, async (err) => {
  if (!isAuthorized.value) {
    throw err;
  }

  const status = err.response?.status;

  if (status === 403) {
    await useKYC();
  }

  if (status === 401) {
    await handle401Error(err);
  }

  throw err;
});
